// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-5182dd98] .success-message{--tw-text-opacity:1;color:rgb(49 37 41/var(--tw-text-opacity))}", "",{"version":3,"sources":["webpack://./resources/js/components/campaign-subscribe.vue"],"names":[],"mappings":"AAEE,mCAAA,mBAAA,CAAA,0CAAA","sourcesContent":["\n::v-deep .success-message {\n  @apply text-gray-900;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
